import React, {Fragment} from 'react';
import './OfferList.less';
import {ListSplitter} from "elements/list-splitter/ListSplitter.tsx";
import {Offer} from "compositions/offer/Offer";

export const OfferList = ({offers}) => {
	return <ul className="offer-list">
		{
			offers.map((offer, index) => <Fragment key={offer.name}>
				{index > 0 && <ListSplitter isAlignByContainer/>}
				<li className="offer-list__item">
					<Offer
						title={offer.name}
						description={offer.desc}
					/>
				</li>
			</Fragment>)
		}
	</ul>
}
